import AppLayout from 'common/components/layouts/AppLayout'
import AuthLayout from 'common/components/layouts/AuthLayout'
import MainLayout from 'common/components/layouts/MainLayout'
import PublicLayout from 'common/components/layouts/PublicLayout'
import FullScreenLayout from 'common/components/layouts/FullScreenLayout'
import ChannelLayout from 'common/components/layouts/ChannelLayout'

import Login from './Login'
import Home from './Home'
import SignUp from './SignUp'
import ConfirmUserInfo from './ConfirmUserInfo'
import ConfirmUser from './ConfirmUser'
import ConfirmRecipient from './ConfirmRecipient'
import ForgottenPassword from './ForgottenPassword'
import RecoverPassword from './RecoverPassword'
import Logout from 'modules/Logout'
import Dashboard from './Dashboard'
import SignUpTrustedUser from './SignUpTrustedUser'
import Channel from './Channel'
import FullScreenLink from './FullScreenLink'
import FullScreen from './FullScreen'
import Alerts from './Alerts'
import Visualisation from './Visualisation'
import Integrations from './Integrations'
import Profile from './Profile'
import NotFound from './NotFound'
import Policy from './PolicyandTerms/containers/Policy'
import Terms from './PolicyandTerms/containers/Terms'
import Cookies from './PolicyandTerms/containers/Cookies'
import ManageCookies from './PolicyandTerms/containers/ManageCookies'
import Reports from './Reports'
import Certifications from './Certifications'
import CheckTrustedUserStatus from './CheckTrustedUserStatus'
import requireAuth from 'utils/requireAuth'
import Project from './Projects'
import * as Routes from 'constants/Routes'
import ConfirmTrustedUser from './ConfirmTrustedUser'
import Device from './Devices'

export default store => {
  return {
    component: AppLayout,
    childRoutes: [
      {
        component: AuthLayout,
        childRoutes: [
          Login(store),
          SignUp(store),
          SignUpTrustedUser(store),
          ConfirmUserInfo(store),
          ConfirmUser(store),
          ConfirmRecipient(store),
          ConfirmTrustedUser(store),
          CheckTrustedUserStatus(store),
          ForgottenPassword(store),
          RecoverPassword(store),
          ManageCookies(store)
        ]
      },
      {
        component: requireAuth(MainLayout),
        path: Routes.MAIN,
        childRoutes: [
          Home(store),
          Dashboard(store),
          Profile(store),
          Integrations(store),
          Visualisation(store),
          FullScreen(store),
          Alerts(store),
          Reports(store),
          Certifications(store),
          Project(store),
          Device(store)
        ]
      },
      {
        component: ChannelLayout,
        path: Routes.CHANNEL,
        childRoutes: [Channel(store)]
      },
      {
        component: PublicLayout,
        childRoutes: [Policy(store), Terms(store), Cookies(store)]
      },
      {
        component: FullScreenLayout,
        childRoutes: [FullScreenLink(store)]
      },
      Logout(store),
      NotFound(store),
      {
        path: '*',
        indexRoute: {
          onEnter: (nextState, replace) => replace(Routes.NOT_FOUND)
        }
      }
    ]
  }
}
